import { Api } from '../../../../../providers/api';
import { BookingGroup } from '../../../../../entities/booking-group';
import { Component } from '@angular/core';
import { DepartureDetailsErrors, DepartureDetailsValidator } from '../../../../../validators/departure-details/validator';
import { InputEvent } from '../../../../../types/booking';
import { AlertController, NavController, NavParams, Platform } from 'ionic-angular';
import { PlaceBookingPage } from '../place-booking/place-booking';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';
import { Vehicle } from '../../../../../entities/vehicle';
import { VehicleType } from '../../../../../entities/vehicle-type';

@Component({
    selector: 'page-departure-details',
    templateUrl: 'departure-details.html',
})
export class DepartureDetailsPage {

    errors: DepartureDetailsErrors = new DepartureDetailsErrors();
    validator: DepartureDetailsValidator = new DepartureDetailsValidator();

    bookings: BookingGroup;

    keyboardShowing: boolean = false;

    vehicleConfig = {
        title: 'Select a vehicle',
    };
    vehicleTypeConfig = {
        title: 'Select a vehicle type',
    };

    vehicles: Vehicle[] = [];
    vehicleTypes: VehicleType[] = [];

    vehicle_id: number;
    vehicle_type_id: number;
    vehicle_reg_disabled: boolean = false;

    constructor(
        private alertCtrl: AlertController,
        private api: Api,
        private navCtrl: NavController,
        private navParams: NavParams,
        private platform: Platform,
        private spinner: SpinnerDialog,
    ) {
        this.bookings = this.navParams.get('bookings');
        this.vehicleTypes = this.navParams.get('vehicleTypes');

        if (this.bookings.vehicle !== undefined) {
            if (this.bookings.vehicle.id !== undefined)
                this.vehicle_id = this.bookings.vehicle.id;
            if (this.bookings.vehicle.type !== undefined && this.bookings.vehicle.type.id !== undefined)
                this.vehicle_type_id = this.bookings.vehicle.type.id;
        }

        if (this.vehicle_type_id === undefined && this.bookings.vehicle_type) {
            this.vehicle_type_id = this.bookings.vehicle_type.id;
            this.setVehicleType();
        }

        this.platform.ready().then( async() => {
            let vehicles: Vehicle[] = await this.api.getMyVehicles(),
                filteredVehicles: Vehicle[] = [];

            for (let v of vehicles) {
                if (v.type === undefined) continue;
                for (let vt of this.vehicleTypes) {
                    if (v.type.id === vt.id) filteredVehicles.push(v);
                }
            }
            this.vehicles = filteredVehicles;
        });
    }

    changeInput(action: InputEvent) {
        this.keyboardShowing = action === 'focus' || action === 'change';
    }

    async nextSection() {
        let validator: DepartureDetailsValidator = new DepartureDetailsValidator(this.bookings);

        if (validator.fails()) {
            this.errors = validator.errors;
            this.validator = validator;
            let prompt = this.alertCtrl.create({
                title: 'Something wasn\'t right there',
                subTitle: 'To continue you must enter valid details in all required fields.',
                buttons: ['OK']
            });
            prompt.present();
            return;
        }
        this.spinner.show();
        this.navCtrl.push(PlaceBookingPage, {bookings: this.bookings});
        this.spinner.hide();
    }

    changeDriverCount(count: number) {
        let drivers: number = this.bookings.drivers;
        drivers = drivers + count;
        if (drivers < 0) drivers = 0;
        if (drivers > 10) drivers = 10;
        this.bookings.drivers = drivers;
    }

    toggleCheckbox(bookingField: string) {
        if (this.bookings[bookingField] === undefined) this.bookings[bookingField] = false;
        this.bookings[bookingField] = !this.bookings[bookingField];
    }

    setLoaded(isChecked: boolean) {
        if (this.bookings.loaded === undefined) this.bookings.loaded = false;
        this.bookings.loaded = isChecked;
    }

    setVehicle() {
        if (this.vehicle_id === -1) {
            // Add new vehicle
            this.bookings.vehicle = new Vehicle();
            this.bookings.vehicle_reg = '';
            this.bookings.trailer_reg = '';
            this.bookings.vehicle_length = null;
            this.bookings.vehicle_width = null;
            this.bookings.vehicle_height = null;
            this.bookings.vehicle_weight = null;
            this.setVehicleType();
            return;
        }
        for (let vehicle of this.vehicles) {
            if (vehicle.id === this.vehicle_id) {
                this.bookings.vehicle = vehicle;
                this.bookings.vehicle_reg = vehicle.vehicle_reg;
                this.bookings.trailer_reg = vehicle.trailer_reg;
                this.bookings.vehicle_length = vehicle.length;
                this.bookings.vehicle_width = vehicle.width;
                this.bookings.vehicle_height = vehicle.height;
                this.bookings.vehicle_weight = vehicle.weight;
                if (vehicle.type !== undefined && vehicle.type !== null) {
                    this.bookings.vehicle_type = vehicle.type;
                    this.vehicle_type_id = vehicle.type.id;
                    this.setVehicleType();
                }
                return;
            }
        }
    }

    setVehicleType() {
        if (this.vehicle_type_id > -1) {
            let vehicleType: VehicleType;

            for (let vt of this.vehicleTypes) {
                if (vt.id === this.vehicle_type_id) {
                    vehicleType = vt;
                }
            }
            if (vehicleType !== undefined) {
                this.bookings.vehicle_type = vehicleType;
                let vehicle: Vehicle = this.bookings.vehicle;
                if (vehicle === undefined)
                    vehicle = new Vehicle();
                vehicle.type = vehicleType;
                this.bookings.vehicle = vehicle;
                this.vehicle_type_id = vehicleType.id;
                if (vehicleType.name.toLowerCase() === 'droptrailer') {
                    // vehicle reg must be emptied before setting the element to disabled
                    this.bookings.vehicle_reg = '';
                    this.vehicle_reg_disabled = true;
                    return;
                }
            }
        }
        this.vehicle_reg_disabled = false;
    }
}



// WEBPACK FOOTER //
// ./src/pages/bookings/my-bookings/create-booking/departure-details/departure-details.ts